export default __webpack_public_path__ + "static/end-points-dont-876e553acbe9f2a37bc3c88d6735b0d58157e9191c22edd045df2e4720af954a.png";